window.PiVehicleFilters = (function () {
  const GROUP_SELECTOR = ':scope > .filterby__list-item, :scope > .pi-filter-dropdown';

  function getGroupKey(group) {
    if (!group) return '';
    const attr = (group.getAttribute('data-pi-vehicle-key') || '').toLowerCase();
    if (attr) return attr;

    const className = (group.className || '').toLowerCase();
    if (className.includes('make')) return 'make';
    if (className.includes('model') || className.includes('modal')) return 'model';
    if (className.includes('year')) return 'year';
    return '';
  }

  function isVehicleGroup(group) {
    return Boolean(getGroupKey(group));
  }

  function getVehicleGroups(form) {
    if (!form) return [];
    const items = Array.from(form.querySelectorAll(GROUP_SELECTOR));
    const vehicleItems = items.filter(isVehicleGroup);
    if (vehicleItems.length) return vehicleItems;
    return items.slice(0, 4);
  }

  function groupInputs(group) {
    return Array.from(group.querySelectorAll('input[type="checkbox"], input[type="radio"]'));
  }

  function resetGroup(group) {
    if (!group) return;
    group.classList.remove('is-selected');
    const label = group.querySelector('.detail-summary-title, .pi-filter-dropdown__label');
    if (!label) return;
    const placeholder = label.getAttribute('data-placeholder') || label.getAttribute('title');
    if (placeholder) label.textContent = placeholder;
  }

  function markSelected(group, input) {
    group.classList.add('is-selected');
    const label = group.querySelector('.detail-summary-title, .pi-filter-dropdown__label');
    const text = input.getAttribute('title') || input.value;
    if (label && text) label.textContent = text;
  }

  function refreshRootState(form) {
    if (!form) return;
    getVehicleGroups(form).forEach((group) => {
      const selected = groupInputs(group).find((input) => input.checked);
      if (selected) markSelected(group, selected);
      else resetGroup(group);
    });

    const root = form.closest('.pi-vehicle-filters');
    if (!root) return;
    const hasSelection = getVehicleGroups(form).some((group) =>
      groupInputs(group).some((input) => input.checked)
    );
    root.classList.toggle('has-vehicle-selection', hasSelection);
    root.querySelectorAll('[data-pi-vehicle-clear]').forEach((clearBtn) => {
      clearBtn.classList.toggle('is-hidden', !hasSelection);
    });
  }

  function closeGroup(input) {
    const details = input.closest('details');
    if (details) details.removeAttribute('open');
  }

  function applyHierarchy(form, input) {
    const groups = getVehicleGroups(form);
    const changedGroup = input.closest('.filterby__list-item, .pi-filter-dropdown');
    if (!changedGroup || !groups.includes(changedGroup)) return;

    const changedIndex = groups.indexOf(changedGroup);

    groupInputs(changedGroup).forEach((el) => {
      if (el !== input) el.checked = false;
    });

    groups.slice(changedIndex + 1).forEach((group) => {
      groupInputs(group).forEach((el) => {
        el.checked = false;
      });
      resetGroup(group);
    });

    if (input.checked) {
      markSelected(changedGroup, input);
    } else {
      resetGroup(changedGroup);
    }

    refreshRootState(form);
    closeGroup(input);
  }

  function clearVehicleGroups(form) {
    getVehicleGroups(form).forEach((group) => {
      groupInputs(group).forEach((el) => {
        el.checked = false;
      });
      resetGroup(group);
    });
    refreshRootState(form);
  }

  function mergeVehicleParams(params, form) {
    if (!params || !form) return params;
    getVehicleGroups(form).forEach((group) => {
      const inputs = groupInputs(group);
      const names = [...new Set(inputs.map((input) => input.name))];
      names.forEach((name) => {
        params.delete(name);
        inputs
          .filter((input) => input.name === name && input.checked)
          .forEach((input) => params.append(name, input.value));
      });
    });
    return params;
  }

  function syncToSidebar(form) {
    const sidebar = document.getElementById('FiltersForm');
    if (!sidebar || !form || sidebar === form) return;

    getVehicleGroups(form).forEach((group) => {
      const inputs = groupInputs(group);
      const names = [...new Set(inputs.map((input) => input.name))];
      names.forEach((name) => {
        const selected = inputs
          .filter((input) => input.name === name && input.checked)
          .map((input) => input.value);
        sidebar.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
          input.checked = selected.includes(input.value);
        });
      });
    });
  }

  function isVehicleInput(input) {
    if (!input || !input.matches('input[type="checkbox"], input[type="radio"]')) return false;
    const form = input.closest('form');
    if (!form || !form.closest('.pi-vehicle-filters')) return false;
    return Boolean(input.closest('.filterby__list-item, .pi-filter-dropdown'));
  }

  function applyCollectionFilters(input, form) {
    syncToSidebar(form);
    const section = document.getElementById('CollectionProductsContainer');
    if (section && typeof getFilterData === 'function') {
      getFilterData(input, section.dataset.id);
    }
  }

  function handleChange(event) {
    const input = event.target;
    if (!isVehicleInput(input)) return;

    const form = input.closest('form');
    applyHierarchy(form, input);

    const banner = form.closest('pi-vehicle-banner');
    if (banner) {
      if (typeof banner.closeAllDropdowns === 'function') banner.closeAllDropdowns();
      if (typeof banner.fetchFilters === 'function') banner.fetchFilters(form);
      return;
    }

    applyCollectionFilters(input, form);
  }

  function handleClear(event) {
    const clearBtn = event.target.closest('[data-pi-vehicle-clear]');
    if (!clearBtn) return;

    event.preventDefault();
    const root = clearBtn.closest('.pi-vehicle-filters');
    const form = root && root.querySelector('form');
    if (!form) return;

    clearVehicleGroups(form);

    const banner = form.closest('pi-vehicle-banner');
    if (banner && typeof banner.fetchFilters === 'function') {
      banner.fetchFilters(null);
      return;
    }

    applyCollectionFilters(clearBtn, form);
  }

  document.addEventListener('change', handleChange);
  document.addEventListener('click', handleClear);

  return {
    applyHierarchy,
    clearVehicleGroups,
    getVehicleGroups,
    mergeVehicleParams,
    refreshRootState,
    syncToSidebar
  };
})();
